import type { Step } from "react-joyride";

/**
 * Versione 2 (2026-09-12): «Cosa manca per l'invio», moduli firmati, privacy e
 * consensi, codice A2A, cancellazione della bozza, invio a mano.
 *
 * Metà dei passi vale solo per certe pratiche: OnboardingTour scarta quelli il
 * cui riquadro non è in pagina, così un utente ne vede in genere sette o otto.
 */
export const dettaglioPraticaVersion = 2;

export const dettaglioPraticaSteps: Step[] = [
  {
    target: '[data-tour="pratica-stepper"]',
    title: "A che punto è",
    content: (
      <p>
        Il percorso della pratica: <em>Bozza → In lavorazione → Attivata</em>. Si
        aggiorna da solo quando il fornitore risponde.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-invio"]',
    title: "Cosa manca per l'invio",
    content: (
      <p>
        L'elenco di ciò che il fornitore pretende prima di accettare la pratica.
        Finché c'è una voce rossa, la pratica resta ferma qui.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-invia-a-mano"]',
    title: "Invia ad A2A",
    content: (
      <p>
        La tua agenzia lavora con una sessione che scade: la pratica pronta parte
        da questo pulsante, non da sola.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-dati"]',
    title: "Dati pratica",
    content: (
      <p>
        Tipo, importo, agenzia e commissione. A invio avvenuto compare anche il{" "}
        <strong>codice A2A</strong>: è il numero da dettare all'assistenza del
        fornitore.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-cliente"]',
    title: "Cliente",
    content: (
      <p>
        Nome, codice fiscale o partita IVA, IBAN. Il nome porta alla scheda
        completa.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-privacy"]',
    title: "Privacy e consensi",
    content: (
      <p>
        Se il cliente ha visto l'informativa e cosa ha acconsentito a ricevere.
        Se non risulta, <strong>Reinvia link privacy</strong> gliela rimanda.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-offerta"]',
    title: "Offerta scelta",
    content: (
      <p>
        Fornitore, prezzo, quota fissa, durata. Si compila quando il cliente
        accetta.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-bollette"]',
    title: "Bollette collegate",
    content: (
      <p>
        Le bollette da cui è nata la pratica. Il nome apre il dettaglio,{" "}
        <strong>Scarica</strong> dà il PDF originale.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-documento"]',
    title: "Documento d'identità",
    content: (
      <p>
        Carta d'identità o passaporto raccolti durante la consulenza.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-moduli"]',
    title: "Moduli da firmare",
    content: (
      <p>
        Volture, subentri e prime attivazioni vogliono moduli firmati.{" "}
        <strong>Genera moduli</strong> li prepara già compilati; una volta
        firmati si ricaricano qui con <strong>Carica firmati</strong> e si dice a
        cosa corrispondono. Senza, la pratica non parte.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratica-cancella"]',
    title: "Cancellare la pratica",
    content: (
      <p>
        Finché è in Bozza si può cancellare. Dopo l'invio no: in quel caso si
        annulla dal fornitore.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
];
